/**
 * Experience Detail Page
 *
 * Public page for viewing an outdoor experience.
 * Shows edit mode if user owns the experience, otherwise shows customer view.
 * Uses MVP 1.20 dynamic page layout with category-specific sections.
 *
 * @version 1.0
 * @created 2025-11-27
 */

import { useParams, useLoaderData } from 'react-router-dom';
import { CustomerExperiencePage } from '../../components/experiences/ExperiencePageLayout';

export default function ExperienceDetail({ onAuthClick }) {
  const { experienceId } = useParams();
  const { categoryL1Id, user: _user, isOwner, experienceDetails } = useLoaderData();

  // Unified experience page - shows edit buttons only if user owns this experience
  return (
    <CustomerExperiencePage
      experienceId={experienceId}
      categoryL1Id={categoryL1Id}
      experienceDetails={experienceDetails}
      isOwner={isOwner}
      onAuthClick={onAuthClick}
    />
  );
}
